exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Website: https://www.4myth.com\n * Email: mythpe@gmail.com\n * Mobile: +966590470092\n * Copyright © 2018-2024  All rights reserved.\n * MyTh Ahmed\n */.v-input--checkbox.v-input--indeterminate.v-input--is-disabled{opacity:.6}.v-input--checkbox.v-input--dense{margin-top:4px}", ""]);

// exports
